import SpeedIcon from '@mui/icons-material/Speed'
import { get } from 'lodash'
import { useRecordContext } from 'react-admin'

import CircularGaugeIcon from '../CircularGaugeIcon'
import UnitField from '../UnitField'
import FieldRow from './FieldRow'

export const getSpeedThresholds = (maxSpeed) => {
  if (!maxSpeed || maxSpeed <= 0) {
    return [{ limit: Infinity, color: '#757575', label: 'speed.unknown' }]
  }

  // Low-speed zones (≤ 50 km/h)
  if (maxSpeed <= 50) {
    return [
      { limit: maxSpeed, color: '#1fd92e', label: 'speed.withinLimit' },
      {
        limit: maxSpeed + 5,
        color: '#ffb74d',
        label: { message: 'speed.lightSpeeding', options: { operator: '+≤', speed: 5, unit: 'km/h' } },
      },
      {
        limit: maxSpeed + 10,
        color: '#ed6c02',
        label: { message: 'speed.moderateSpeeding', options: { operator: '+≤', speed: 10, unit: 'km/h' } },
      },
      {
        limit: Infinity,
        color: '#d32f2f',
        label: { message: 'speed.excessiveSpeeding', options: { operator: '>+', speed: 10, unit: ' km/h' } },
      },
    ]
  }

  // Normal roads / highways
  return [
    { limit: maxSpeed, color: '#1fd92e', label: 'speed.withinLimit' },
    {
      limit: maxSpeed * 1.1,
      color: '#ffb74d',
      label: { message: 'speed.lightSpeeding', options: { operator: '≤', speed: 10, unit: '%' } },
    },
    {
      limit: maxSpeed * 1.25,
      color: '#ed6c02',
      label: { message: 'speed.moderateSpeeding', options: { operator: '≤', speed: 25, unit: '%' } },
    },
    {
      limit: Infinity,
      color: '#d32f2f',
      label: { message: 'speed.excessiveSpeeding', options: { operator: '>', speed: 25, unit: '%' } },
    },
  ]
}

const SpeedField = ({ source = 'speed', max_speed, icon = SpeedIcon, ...props }) => {
  const record = useRecordContext(props)
  const { helperText, ...rest } = props
  return (
    <FieldRow
      icon={<CircularGaugeIcon Icon={icon} thresholds={getSpeedThresholds(max_speed)} value={get(record, source)} />}
      helperText={helperText}
    >
      <UnitField source={source} unit="km/h" {...rest} />
    </FieldRow>
  )
}

export default SpeedField
